export enum StatusTarefa{
  Planejamento ,
  Afazer,
  EmAndamento,
  Validacao,
  Fechada,
  Desativado
}
